import {
    useContext
} from 'react';
import {
    DocumentSectionContext
} from '../knowledgeBuilderContext/DocumentSectionContext';
import {
    KBContext
} from '../knowledgeBuilderContext/KBGlobalContext';
import {
    Context
} from 'shared/context/GlobalState';
import {
    Input
} from 'shared/components/ui/input';
import {
    Button
} from 'shared/components/ui/button';
import {
    Search, RefreshCcw, Trash2
} from 'lucide-react';
import {
    Tooltip, TooltipProvider, TooltipTrigger
} from 'shared/components/ui/tooltip';
import {
    cn
} from 'shared/lib/utils';
import KBTooltipContent from './KBTooltipContent';

export function InterfaceButton({
    onClick, content, tooltip, disabled, className, variant = 'ghost'
}) {
    return (
        <TooltipProvider>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button
                        variant={variant}
                        className={cn('p-2 h-fit w-fit', className)}
                        onClick={onClick}
                        disabled={disabled}
                    >
                        {content}
                    </Button>
                </TooltipTrigger>
                <KBTooltipContent tooltipText={tooltip} />
            </Tooltip>
        </TooltipProvider>
    );
}

export default function DocumentInterface() {
    const {
        searchQuery, setSearchQuery, searchCurrentFolder, selectedDocs, setSelectedDocs
    } = useContext(DocumentSectionContext);
    const {
        refreshList, deleteObject
    } = useContext(KBContext);
    const {
        addNewNotifcation
    } = useContext(Context);

    return (
        <div className="flex items-center justify-between mb-2 gap-2 border-b pb-2">
            <div className="flex items-center gap-2">
                <div className="flex items-center border border-input rounded-md px-3 bg-background w-full max-w-sm focus-within:ring-1 focus-within:ring-ring">
                    <Search className="h-4 w-4 text-muted-foreground mr-2 shrink-0" />
                    <Input
                        placeholder="Search documents..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                searchCurrentFolder();
                            }
                        }}
                        className="border-0 shadow-none focus-visible:ring-0 px-0 h-9"
                    />
                </div>
                <InterfaceButton
                    onClick={() => searchCurrentFolder()}
                    content={<Search size={18} />}
                    tooltip="Search"
                    variant="ghost"
                />
            </div>
            <div className="flex items-center gap-1">
                <InterfaceButton
                    onClick={() => refreshList()}
                    content={<RefreshCcw size={18} />}
                    tooltip="Refresh List"
                />
                <InterfaceButton
                    onClick={() => {
                        if (selectedDocs.size === 0) {
                            addNewNotifcation('No items selected for deletion', 'warning');
                            return;
                        }
                        // Proceed with deletion directly - user already clicked the delete button
                        deleteObject(Array.from(selectedDocs)).then(() => {
                            addNewNotifcation(`Successfully deleted ${selectedDocs.size} item(s)`, 'success');
                            setSelectedDocs(new Set());
                            refreshList();
                        }).catch((error) => {
                            addNewNotifcation('Failed to delete items. Please try again.', 'danger');
                            console.error('Delete error:', error);
                        });
                    }}
                    content={<Trash2 size={18} />}
                    tooltip="Delete Selected"
                    disabled={selectedDocs.size === 0}
                    className="text-red-500 hover:text-red-600 hover:bg-red-50"
                />
            </div>
        </div>
    );
}